import React from "react";

const Welcome = () => {
  return (
    <section>
      <h1>This is Welcome Page!!!</h1>
    </section>
  );
};

export default Welcome;
